import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleLanguage = () => {
    const newLocale = currentLanguage === 'es' ? 'en' : 'es';

    // Update the language in context
    changeLanguage(newLocale);

    // Update the URL to reflect the new language
    const pathSegments = location.pathname.split('/');
    if (pathSegments[1] === 'es' || pathSegments[1] === 'en') {
      // Replace the current locale in the URL
      pathSegments[1] = newLocale;
      navigate(pathSegments.join('/'));
    } else {
      // If no locale in URL, prepend the new locale
      navigate(`/${newLocale}${location.pathname}`);
    }
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      aria-label={`Switch to ${currentLanguage === 'es' ? 'English' : 'Español'}`}
      className="flex items-center gap-2"
    >
      <Globe className="h-4 w-4" />
      <span className="hidden sm:inline-block">
        {currentLanguage === 'es' ? 'EN' : 'ES'}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;